<template>
    <v-dialog v-model="dialogStatus" max-width="80vw" persistent>
        <v-form ref="form" v-model="validForm" @submit.prevent="submit">
            <v-card>
                <v-card-title>
                    <v-icon left>
                        {{ 
                            dialogType == 'new' ? 'mdi-cart-arrow-up' : 'mdi-pencil-box-multiple' 
                        }}
                    </v-icon>
                    {{ 
                        dialogType == 'new' ? 'New Order Requisition:' : 'Edit Order Requisition:' 
                    }}
                    <v-spacer />
                </v-card-title>
                <v-card-text>
                    <v-row no-gutters class="ma-1">
                        <v-col cols="12" md="4" class="pr-2">
                            <v-text-field
                                v-model="orderForm.id"
                                label="Order ID"
                                readonly
                                disabled
                                dense
                                style="cursor: not-allowed !important;"
                                prepend-inner-icon="mdi-numeric"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>

                        <!-- <v-col cols="12" md="4" class="px-2">
                            <v-text-field
                                v-model="orderForm.order_requisition_issued_at"
                                label="Order Requisition Date"
                                prepend-inner-icon="mdi-calendar"
                                single-line
                                placeholder="YYYY-MM-DD"
                                v-mask="'####-##-##'"
                                outlined
                                hint="The date the requisition was created"
                                persistent-hint
                                readonly
                                dense
                            ></v-text-field>
                        </v-col> -->

                        <v-col cols="12" md="2" class="pr-2">
                            <v-menu
                                v-model="dateMenu.order_requested_date"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="orderForm.order_requested_date"
                                        label="Requested Date"
                                        prepend-inner-icon="mdi-calendar"
                                        single-line
                                        placeholder="YYYY-MM-DD"
                                        v-mask="'####-##-##'"
                                        outlined
                                        hint="Select the requested date"
                                        persistent-hint
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="orderForm.order_requested_date"
                                    no-title
                                    @input="dateMenu.order_requested_date = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" md="2" class="pr-2">
                            <v-text-field
                                v-model="orderForm.order_retain_time"
                                label="Retain Time"
                                dense
                                prepend-inner-icon="mdi-clock-fast"
                                outlined
                                hint="Enter the retain time"
                                persistent-hint
                                class="rounded-0"
                                v-mask="'##:##'"
                            />
                        </v-col>

                        <v-col cols="12" md="2" class="pr-2">
                            <v-menu
                                v-model="dateMenu.order_runout_date"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="orderForm.order_runout_date"
                                        label="Runout Date"
                                        prepend-inner-icon="mdi-calendar"
                                        single-line
                                        placeholder="YYYY-MM-DD"
                                        v-mask="'####-##-##'"
                                        outlined
                                        hint="Select the runout date"
                                        persistent-hint
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="orderForm.order_runout_date"
                                    no-title
                                    @input="dateMenu.order_runout_date = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="orderForm.order_runout_time"
                                label="Runout Time"
                                dense
                                hint="Enter the runout time"
                                persistent-hint
                                prepend-inner-icon="mdi-clock-end"
                                outlined
                                class="rounded-0"
                                v-mask="'##:##'"
                            />
                        </v-col>
                    </v-row>
                    
                    <v-row no-gutters class="ma-1 mt-5">
                        <v-col
                            cols="12"
                            md="4"
                            class="pr-2"
                        >
                            <v-autocomplete
                                v-model="orderForm.terminal_id"
                                :items="collections.terminals"
                                item-text="name"
                                item-value="id"
                                label="Terminal"
                                dense
                                prepend-inner-icon="mdi-diving-scuba-tank-multiple"
                                :append-icon="
                                    loading.collections ? 'mdi-loading mdi-spin' : ''
                                "
                                outlined
                                class="rounded-0"
                                :rules="[rules.required]"
                                hint="Where will the product be loaded?"
                                persistent-hint
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                            class="px-2"
                        >
                            <v-autocomplete
                                v-model="orderForm.supplier_id"
                                :items="collections.suppliers"
                                item-text="name"
                                item-value="id"
                                label="Supplier"
                                hint="Select the supplier"
                                persistent-hint
                                dense
                                prepend-inner-icon="mdi-account-supervisor"
                                :append-icon="
                                    loading.collections ? 'mdi-loading mdi-spin' : ''
                                "
                                outlined
                                class="rounded-0"
                                :rules="[rules.required]"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                            class="pl-2"
                        >
                            <v-autocomplete
                                v-model="orderForm.station_id"
                                :items="collections.stations"
                                item-text="name"
                                item-value="id"
                                label="Station"
                                dense
                                prepend-inner-icon="mdi-gas-station"
                                :append-icon="
                                    loading.collections ? 'mdi-loading mdi-spin' : ''
                                "
                                outlined
                                class="rounded-0"
                                :rules="[rules.required]"
                                hint="Where will the product be taken to?"
                                persistent-hint
                            />
                        </v-col>
                    </v-row>
                    
                    <v-row no-gutters class="ma-1 mt-5">
                        <v-col cols="12" md="12">
                            <v-textarea
                                v-model="orderForm.special_instructions"
                                label="Special Instructions"
                                hint="You can write special instructions on your order request here"
                                persistent-hint
                                dense
                                rows="3"
                                outlined
                                hide-details
                                class="rounded-0"
                            />
                        </v-col>
                    </v-row>

                    <v-row justify="center">
                        <v-col cols="12" md="12">
                            <v-card :disabled="disabledOrderRequisitionDetails">
                                <!-- <v-card-title>
                                    <v-icon left>mdi-barrel</v-icon>
                                    Order Requisition Details:
                                </v-card-title> -->
                                <v-card-text>
                                    <v-row no-gutters class="ma-1">
                                        <v-data-table
                                            :headers="orderRequisitionDetailsHeaders"
                                            :items="orderForm.details"
                                            dense
                                            height="200px"
                                            hide-default-footer
                                            disable-pagination
                                            disable-sort
                                            style="width: 100%;"
                                        >
                                            <template v-slot:top>
                                                <v-toolbar dark color="#6B6DFD" dense>
                                                    <v-spacer/>
                                                    <v-toolbar-title class="white--text">
                                                        Order Requisition Details
                                                    </v-toolbar-title>
                                                    <v-spacer/>
                                                    <v-btn 
                                                        large 
                                                        icon 
                                                        @click="addProductRow()"
                                                    >
                                                        <v-icon>mdi-plus</v-icon>
                                                    </v-btn>
                                                </v-toolbar>
                                            </template>
                                            <template v-slot:item.product="{ item }">
                                                <v-autocomplete
                                                    v-model="item.product"
                                                    :items="filteredProducts"
                                                    item-text="name"
                                                    item-value="id"
                                                    auto-select-first
                                                    return-object
                                                    dense
                                                    @change="handleSelectedProduct(item)"
                                                ></v-autocomplete>
                                            </template>
                                            <template v-slot:item.product_code="{ item }">
                                                <v-text-field
                                                    v-model="item.product_code"
                                                    dense
                                                    readonly
                                                ></v-text-field>
                                            </template>
                                            <template v-slot:item.product_quantity="{ item }">
                                                <v-text-field
                                                    :value="formatNumberWithCommas(item.product_quantity)"
                                                    :rules="orderRequisitionDetailsRules"
                                                    type="text"
                                                    dense
                                                    @input="updateProductQuantity($event, item)"
                                                ></v-text-field>
                                            </template>
                                            <template v-slot:item.delete="{ item }">
                                                <v-btn
                                                    color="secondary"
                                                    icon
                                                    dark
                                                    @click="deleteProductRow(item)"
                                                >
                                                    <v-icon>mdi-minus</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <small class="red--text">*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!--<v-btn
                        color="blue darken-1"
                        text
                        @click="resetForm()"
                        :disabled="dialogType !== 'new'"
                    >
                        Clear
                    </v-btn>-->
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="handleCloseOrderRequisitionDialog()"
                    >
                        Close
                    </v-btn>
                    <v-btn
                        v-if="dialogType == 'new'"
                        color="blue darken-1"
                        text
                        type="submit"
                        :disabled="!validForm"
                    >
                        Save
                    </v-btn>
                    <v-btn
                        v-if="dialogType == 'edit'"
                        color="blue darken-1"
                        text
                        type="submit"
                        :disabled="!validForm"
                    >
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { validations } from '@/Utils/validation';
import { mask } from 'vue-the-mask';
import axios from 'axios';
// import { mapGetters } from 'vuex';

export default {
    name: 'OrderRequisitionDialog',
    directives: { mask },
    props: {
        dialogStatus: {
            type: Boolean,
            default: false
        },
        dialogType: String,
        orderHistoryItem: Object,
        currentUserApp: Object,
        collections: Object,
        loading: Object
    },
    components: {

    },
    data: function () {
        return {
            validForm: true,
            rules: validations,
            orderForm: {
                id: null,
                // order_requisition_issued_at: this.getCurrentDate(),
                order_requested_date: null,
                order_retain_time: null,
                order_runout_date: null,
                order_runout_time: null,
                terminal_id: null,
                supplier_id: null,
                station_id: null,
                special_instructions: null,
                details: [],
            },
            // collections: {},
            // loading: {
            //     collections: true,
            // },
            orderRequisitionDetailsHeaders: [
                { text: 'Product', value: 'product', class: 'custom-header-details' },
                { text: 'Product Code', value: 'product_code', class: 'custom-header-details' },
                { text: 'Quantity', value: 'product_quantity', class: 'custom-header-details' },
                { text: 'Delete', value: 'delete', class: 'custom-header-details' },
            ],
            orderRequisitionDetailsRules: [
                v => !!v || 'This field is required',
                v => this.isValidAmount(v) || 'Amount should not be above 60,000'
            ],
            dateMenu: {
                order_requested_date: false,
                order_runout_date: false,
            },
            disabledOrderRequisitionDetails: true,
        }
    },
    mounted() {
        // this.getCollections();
        this.addProductRow();
    },
    computed: {
        // ...mapGetters(['getActiveUsers']),
        // activeUsers() {
        //     return this.getActiveUsers;
        // },
        filteredProducts() {
            if (this.orderForm.terminal_id != null && this.orderForm.supplier_id != null) {
                let filteredProducts = this.collections.products.filter(prd => {
                    return prd.Terminal == this.orderForm.terminal_id;
                }).filter(prd => {
                    return prd.Supplier == this.orderForm.supplier_id;
                });

                console.log('Filtered products: ', filteredProducts);
                this.disabledOrderRequisitionDetails = false;
                return filteredProducts;
            }
            return [];
        }
    },
    watch: {
        dialogStatus(newVal) {
            if (this.dialogType == 'edit' && newVal) {
                console.log('Order history item: ', this.orderHistoryItem);
                this.orderForm = {
                    id: this.orderHistoryItem.OrderID,
                    // order_requisition_issued_at: this.orderHistoryItem.order_requisition_issued_at,
                    order_requested_date: this.orderHistoryItem.order_requested_date,
                    order_retain_time: this.orderHistoryItem.order_retain_time,
                    order_runout_date: this.orderHistoryItem.order_runout_date,
                    order_runout_time: this.orderHistoryItem.order_runout_time,
                    terminal_id: this.orderHistoryItem.terminal_id,
                    supplier_id: this.orderHistoryItem.supplier_id,
                    station_id: this.orderHistoryItem.station_id,
                    special_instructions: this.orderHistoryItem.special_instructions,
                    details: [],
                };

                this.orderForm.details = this.orderHistoryItem.order_details.map(det => {
                    return {
                        product: this.filteredProducts.filter(prd => det.product_id == prd.id)[0],
                        product_code: det.product_code,
                        product_quantity: det.product_quantity,
                        id: det.OrderProdID,
                    };
                });
            }
        },
        // 'orderForm.terminal_id': {
        //     handler(newVal, oldVal) {
        //         if (newVal === oldVal) {
        //             return;
        //         }
        //         console.log('Terminal changed from ', oldVal, ' to ', newVal);
        //         this.collections.filteredProducts = this.collections.filteredProducts.filter(prd => {
        //             return prd.Terminal == newVal;
        //         });
        //         console.log('Filtered products ', this.collections.filteredProducts);

        //         // Handle disabled order requisition details
        //         if (this.orderForm.terminal_id != null && this.orderForm.supplier_id != null) {
        //             this.disabledOrderRequisitionDetails = false;
        //         }
        //     },
        //     deep: true
        // },
        // 'orderForm.supplier_id': {
        //     handler(newVal, oldVal) {
        //         if (newVal === oldVal) {
        //             return;
        //         }
        //         console.log('Supplier changed from ', oldVal, ' to ', newVal);
        //         this.collections.filteredProducts = this.collections.filteredProducts.filter(prd => {
        //             return prd.Supplier == newVal;
        //         });
        //         console.log('Filtered products ', this.collections.filteredProducts);

        //         // Handle disabled order requisition details
        //         if (this.orderForm.terminal_id != null && this.orderForm.supplier_id != null) {
        //             this.disabledOrderRequisitionDetails = false;
        //         }
        //     },
        //     deep: true
        // },
    },
    methods: {
        handleSelectedProduct(item) {
            console.log('Selected product: ', item);
            item.product_code = item.product.Code;
        },
        // getCollections() {
        //     console.log('Get collections');
        //     console.log(this.currentUserApp);
        //     axios
        //         .get(
        //             'customers/order-requisition/collections/' + this.currentUserApp.id
        //         )
        //         .then(response => {
        //             console.log(response.data);
        //             let data = response.data;
        //             this.collections.terminals = data.terminals;
        //             this.collections.stations = data.stations;
        //             this.collections.suppliers = data.suppliers;
        //             this.collections.products = data.products;
        //             // this.collections.filteredProducts = data.products;
        //             this.loading.collections = false;
        //         })
        //         .catch(error => {
        //             console.error(error);
        //         });
        // },
        submit() {
            console.log('Submit form');
            console.log(this.orderForm);
            // console.log(this.currentUserApp);

            let orderRequisition = {
                order_requested_date: this.orderForm.order_requested_date,
                order_retain_time: this.orderForm.order_retain_time,
                order_runout_date: this.orderForm.order_runout_date,
                order_runout_time: this.orderForm.order_runout_time,
                terminal_id: this.orderForm.terminal_id,
                supplier_id: this.orderForm.supplier_id,
                station_id: this.orderForm.station_id,
                special_instructions: this.orderForm.special_instructions
            };

            if (this.dialogType == 'edit') {
                orderRequisition.id = this.orderForm.id;
            }

            let orderRequisitionDetails = [];
            if (this.dialogType == 'new') {
                orderRequisitionDetails = this.orderForm.details.map(det => {
                    return {
                        customer_order_requisition_id: null,
                        product_id: det.product.id,
                        product_code: det.product_code,
                        product_quantity: det.product_quantity
                    }
                });
            } else if (this.dialogType == 'edit') {
                orderRequisitionDetails = this.orderForm.details.map(det => {
                    return {
                        id: det.id ? det.id : 'new',
                        customer_order_requisition_id: this.orderForm.id,
                        product_id: det.product.id,
                        product_code: det.product_code,
                        product_quantity: det.product_quantity
                    }
                });
            }

            let payload = {
                orderRequisition, orderRequisitionDetails
            };

            let str = this.$store;
            str.state.isLoading = true;

            console.log('Payload ', payload);
            if (this.dialogType == 'new') {
                axios
                    .post(
                        'customers/order-requisition/create', payload
                    )
                    .then(response => {
                        console.log(response.data);
                        str.state.isLoading = false;
                        this.handleCloseOrderRequisitionDialog();
                        this.$store.dispatch('setSnackbar', {
                            text: 'Order requisition successfully created',
                            color: 'success'
                        });
                        this.$emit('update:history');
                    })
                    .catch(error => {
                        str.state.isLoading = false;
                        console.error(error);
                    });
            } else if (this.dialogType == 'edit') {
                axios
                    .put(
                        'customers/order-requisition/update', payload
                    )
                    .then(response => {
                        console.log(response.data);
                        str.state.isLoading = false;
                        this.handleCloseOrderRequisitionDialog();
                        this.$store.dispatch('setSnackbar', {
                            text: 'Order requisition successfully updated',
                            color: 'success'
                        });
                        this.$emit('update:history');
                    })
                    .catch(error => {
                        str.state.isLoading = false;
                        console.error(error);
                    });
            }
        },
        handleCloseOrderRequisitionDialog() {
            console.log('Close order requisition dialog');

            this.orderForm = {
                id: null,
                // order_requisition_issued_at: this.getCurrentDate(),
                order_requested_date: null,
                order_retain_time: null,
                order_runout_date: null,
                order_runout_time: null,
                terminal_id: null,
                supplier_id: null,
                station_id: null,
                special_instructions: null,
                details: [],
            };

            this.addProductRow();
            this.disabledOrderRequisitionDetails = true;

            this.$refs.form.reset();
            console.log('Order form ', this.orderForm);
            this.$emit('close:dialog');
        },
        addProductRow() {
            let newProduct = {
                product: '',
                product_code: '',
                product_quantity: '',
            };
            this.orderForm.details.push(newProduct);
        },
        deleteProductRow(item) {
            console.log('Delete product row');
            console.log(item);
            let idx = this.orderForm.details.findIndex(obj => obj === item);
            if (idx !== -1) {
                this.orderForm.details.splice(idx, 1);
            }
            console.log('Item deleted: ', this.orderForm.details);
        },
        getCurrentDate() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        formatNumber(value, decimalPlaces = 2) {
            const number = parseFloat(value);

            return number.toLocaleString('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            });
        },
        formatNumberWithCommas(value) {
            if (!value) return '';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        updateProductQuantity(value, item) {
            if (!value) return;
            const numericValue = value.replace(/,/g, '');
            item.product_quantity = Number(numericValue);
            console.log(this.orderForm.details);
        },
        isValidAmount(value) {
            if (!value) return false;
            const numericValue = value.replace(/,/g, '');
            return numericValue <= 60000;
        }
    },
};
</script>

<style>
    .custom-header-details {
        background-color: #787879!important;
        color: #fff!important;
    }
</style>